import React, { forwardRef, useLayoutEffect, useRef } from 'react';
import { LoadOptions, loader } from './loader';
import { IconNamesType, IconSvgProps } from "./Icon.types";
import { getColor } from "@mrocket/styles";


export interface IconDefaultProps extends
  IconSvgProps,
  React.PropsWithoutRef<Omit<React.SVGProps<SVGSVGElement>, 'color'>>
{
  name: IconNamesType;
  ref?: React.Ref<SVGSVGElement>
}

export interface IconProps extends IconDefaultProps, LoadOptions {}

/**
 * Default SVG component for locally reusing SVG DOM elements that have already been rendered
 *
 * */
export const Icon = forwardRef<SVGSVGElement, IconProps>((
  {
    timeout,
    retryCount,
    flushImmediate,
    size = 24,
    color = 'currentColor',
    name,
    ...props
  },
  ref
) => {

  const firstRunRef = useRef(true)

  useLayoutEffect(() => {
    loader.load(
      name,
      {
        timeout: timeout,
        retryCount: retryCount,
        flushImmediate: firstRunRef.current ? false : flushImmediate
      }
    ).catch((reason) => {
      console.debug(reason)
    })
    if (firstRunRef.current) {
      firstRunRef.current = false
    }
  }, [timeout, retryCount, flushImmediate, name])

  const hrefId = `#${loader.getId(name)}`

  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      color={getColor(color)}
      d={''}
      {...props}
    >
      <use href={hrefId}/>
    </svg>
  )
});


Icon.displayName = 'Icon'
